import addEnumMethods from './addEnumMethods';

const PlacementMode = {
    None: 0,
    Preview: 1
};

export default addEnumMethods(PlacementMode);